import { SvgIcon } from '@mui/material';

export function RemoveIcon(props) {
	return (
		<SvgIcon
			width="24"
			height="24"
			viewBox="0 0 24 24"
			fill="none"
			{...props}
		>
			<path
				id="Vector"
				d="M5.5 12.7499V11.25H18.5V12.7499H5.5Z"
				fill="currentColor"
			/>
		</SvgIcon>
	);
}
